var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D5D5D5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V6.7H15.8C16.2167 6.7 16.5708 6.84583 16.8625 7.1375C17.1542 7.42917 17.3 7.78333 17.3 8.2V21H4.5ZM6.175 18.425H14.25C14.4167 18.425 14.5333 18.3583 14.6 18.225C14.6667 18.0917 14.65 17.9583 14.55 17.825L12.025 14.5C11.9417 14.4 11.8417 14.35 11.725 14.35C11.6083 14.35 11.5083 14.4 11.425 14.5L9.225 17.525L8 15.8C7.91667 15.7 7.81667 15.65 7.7 15.65C7.58333 15.65 7.48333 15.7 7.4 15.8L5.875 17.825C5.775 17.9583 5.75833 18.0917 5.825 18.225C5.89167 18.3583 6.00833 18.425 6.175 18.425ZM3 4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3V4.5H3ZM10.975 4.5V3H13.05V4.5H10.975ZM19.5 4.5V3C19.9 3 20.25 3.15 20.55 3.45C20.85 3.75 21 4.1 21 4.5H19.5ZM6.7 4.5V3H8.775V4.5H6.7ZM19.5 13.025V10.95H21V13.025H19.5ZM19.5 21V19.5H21C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21ZM19.5 8.775V6.7H21V8.775H19.5ZM19.5 17.3V15.225H21V17.3H19.5ZM15.225 4.5V3H17.3V4.5H15.225Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.719c7203d43fe64fdde23ad63cb752aa.svg";
export { ForwardRef as ReactComponent };